<ng-previous-requests-form-container></ng-previous-requests-form-container>
<ng-previous-requests
  *ngIf="(store$ | async) as store"
  [submittedDiversions]="store.requests"
  [loading]="store.loading"
></ng-previous-requests>
